import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServiceList from "./sections/ServiceList";
import ServiceVideos from "./sections/ServiceVideos";
import Video from "./sections/Video";
import VideoCopy from "./sections/VideoCopy";
import About from "./sections/About";
import ImageAndTextSplit from "./sections/ImageAndTextSplit";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServiceList />
      <ServiceVideos />
      <Video />
      <VideoCopy />
      <About />
      <ImageAndTextSplit />
      <Footer />
    </div>;
}